import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	loadingMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loadingMessageIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	loadingMessage: {
		id: 'issue-navigator.issue-results.detail-view.card-container.loading-manager.loading-indicator.loading-message',
		defaultMessage: 'Loading more issues',
		description: 'Text displayed in the loading indicator when more table rows are being loaded',
	},
	loadingMessageIssueTermRefresh: {
		id: 'issue-navigator.issue-results.detail-view.card-container.loading-manager.loading-indicator.loading-message-issue-term-refresh',
		defaultMessage: 'Loading more work items',
		description: 'Text displayed in the loading indicator when more table rows are being loaded',
	},
});
export default messages;
